module.exports = __webpack_public_path__ + "img/Blog5.c5e81d78.png";